(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[975],{

/***/ 4309:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/anlaggning/[slug]",
      function () {
        return __webpack_require__(809);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 3636:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ HeadMeta; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);



function HeadMeta(meta) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: meta.title || "".concat(meta.nodeName, " | Mitt Lager")
            }, "title"),
            meta.description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: meta.description
            }, "description"),
            meta.canonical && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: meta.canonical
            })
        ]
    });
}


/***/ }),

/***/ 9841:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8527);
/* harmony import */ var constants_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3244);
/* harmony import */ var helpers_discounts__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2940);






var CampaignBanner = function(param) {
    var campaigns = param.campaigns, campaignLevel = param.campaignLevel, id = param.id, title = param.title;
    var filteredCampaign = campaigns === null || campaigns === void 0 ? void 0 : campaigns.filter(function(campaign) {
        return campaign.isActive;
    });
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), activeCampaigns = ref[0], setActiveCampaigns = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), activeDiscounts = ref1[0], setActiveDiscounts = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), discountIndex = ref2[0], setDiscountIndex = ref2[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var sortedCampaigns = [];
        if (campaignLevel === "Top") {
            sortedCampaigns = filteredCampaign === null || filteredCampaign === void 0 ? void 0 : filteredCampaign.filter(function(campaign) {
                return campaign.appliesToAll;
            });
        } else if (campaignLevel === "Facility") {
            sortedCampaigns = filteredCampaign === null || filteredCampaign === void 0 ? void 0 : filteredCampaign.filter(function(campaign) {
                return campaign.appliesToFacilityId.includes(id);
            });
        }
        setActiveCampaigns(sortedCampaigns);
    }, [
        id
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        activeCampaigns === null || activeCampaigns === void 0 ? void 0 : activeCampaigns.forEach(function(campaign) {
            if (campaign.discounts.length > 0) {
                setActiveDiscounts((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(activeDiscounts).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(campaign.discounts)));
            }
        });
    }, [
        activeCampaigns
    ]);
    var titleText = function(discount) {
        var titleText = "JUST NU:";
        if (discount !== undefined) {
            if (campaignLevel === "Facility" && title) {
                titleText = "JUST NU i ".concat(title.toLocaleUpperCase(), " p\xe5 utvalda f\xf6rr\xe5d:");
            }
        }
        return titleText;
    };
    console.log({
        activeCampaigns: activeCampaigns
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: (activeCampaigns === null || activeCampaigns === void 0 ? void 0 : activeCampaigns.length) > 0 && activeDiscounts.length && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .xu, {
            py: 3,
            backgroundColor: constants_constants__WEBPACK_IMPORTED_MODULE_2__/* .colors.system.error[900] */ .O9.system.error[900],
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .xu, {
                color: constants_constants__WEBPACK_IMPORTED_MODULE_2__/* .colors.white */ .O9.white,
                style: {
                    display: "flex",
                    justifyContent: "center"
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .xu, {
                        fontWeight: 600,
                        mr: 3,
                        children: titleText(activeDiscounts[discountIndex])
                    }),
                    " ",
                    (0,helpers_discounts__WEBPACK_IMPORTED_MODULE_5__/* .discountText */ .LT)(activeDiscounts[discountIndex])
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CampaignBanner);


/***/ }),

/***/ 9410:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8527);
/* harmony import */ var constants_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3244);
/* harmony import */ var helpers_discounts__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2940);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);





var monthString = " /m\xe5n";
var DiscountPrice = function(param) {
    var price = param.price, discount = param.discount, _showMonth = param.showMonth, showMonth = _showMonth === void 0 ? true : _showMonth;
    var roundedPrice = Math.round(price * 100) / 100;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
        mb: 5,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
                style: {
                    fontSize: 14,
                    textDecoration: "line-through",
                    color: constants_constants__WEBPACK_IMPORTED_MODULE_1__/* .colors.secondary.mediumGrey */ .O9.secondary.mediumGrey
                },
                children: [
                    price,
                    ":- ",
                    showMonth && monthString,
                    " ordinarie pris"
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
                style: {
                    fontSize: 28,
                    color: constants_constants__WEBPACK_IMPORTED_MODULE_1__/* .colors.system.error[900] */ .O9.system.error[900],
                    fontWeight: 600
                },
                children: [
                    (0,helpers_discounts__WEBPACK_IMPORTED_MODULE_4__/* .getDiscountPrice */ .lk)(roundedPrice, discount),
                    ":-",
                    showMonth && monthString
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (DiscountPrice);


/***/ }),

/***/ 2940:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LT": function() { return /* binding */ discountText; },
/* harmony export */   "lk": function() { return /* binding */ getDiscountPrice; },
/* harmony export */   "vN": function() { return /* binding */ getBestDiscount; }
/* harmony export */ });
/* unused harmony export checkAvailbleDiscounts */
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9815);

var checkAvailbleDiscounts = function(campaigns, campaignLevel, facilityId, unitId) {
    var activeCampaigns = [];
    var activeDiscounts = [];
    if (campaignLevel === "Top") {
        activeCampaigns = campaigns.filter(function(campaign) {
            return campaign.appliesToAll;
        });
    } else if (campaignLevel === "Facility") {
        activeCampaigns = campaigns.filter(function(campaign) {
            return campaign.appliesToFacilityId.includes(facilityId);
        });
    } else if (campaignLevel === "Unit") {
        activeCampaigns = campaigns.filter(function(campaign) {
            return campaign.appliesToAll || campaign.appliesToFacilityId.includes(facilityId);
        });
    }
    if (campaignLevel === "Unit") {
        activeCampaigns.forEach(function(campaign) {
            return activeDiscounts = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(activeDiscounts).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(campaign.discounts.filter(function(discount) {
                return discount.appliesToAll || discount.appliesToProductId.includes(unitId);
            })));
        });
    } else {
        activeCampaigns.forEach(function(campaign) {
            return activeDiscounts = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(activeDiscounts).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(campaign.discounts));
        });
    }
    return activeDiscounts;
};
var calcuteDiscountedPrice = function(price, discount) {
    return discount.discountType === "fixed" ? price - discount.amountOff : price * (1 - discount.percentOff / 100);
};
var getDiscountPrice = function(price, discount) {
    var returnPrice = price;
    var discountPrice = calcuteDiscountedPrice(price, discount);
    if (discountPrice < returnPrice) {
        returnPrice = discountPrice > 0 ? discountPrice : 0;
    }
    return Math.round(returnPrice * 100) / 100;
};
var getBestDiscount = function(price, discounts) {
    var returnDiscount;
    discounts.forEach(function(discount) {
        if (returnDiscount === undefined) {
            returnDiscount = discount;
        } else {
            var currentDiscountPrice = calcuteDiscountedPrice(price, returnDiscount);
            if (currentDiscountPrice > calcuteDiscountedPrice(price, discount)) {
                returnDiscount = discount;
            }
        }
    });
    return returnDiscount;
};
var discountText = function(discount) {
    if (discount !== undefined) {
        var val = "kr";
        if (discount.discountType === "percent") {
            val = "%";
        }
        var length = "under din f\xf6rsta m\xe5nad";
        if (!discount.includeFirstMonth) {
            length = "under din f\xf6rsta hela m\xe5nad";
        }
        if (discount.discountedMonths > 0) {
            length = "under ".concat(discount.discountedMonths, " m\xe5nader");
        }
        var condition = "";
        if (discount.requireFirstOrder) {
            condition = ", g\xe4ller endast nya kunder";
        }
        return "".concat(discount.discountType === "percent" ? discount.discountValue : discount.amountOff).concat(val, " rabatt ").concat(length).concat(condition, ".");
    }
};
/* harmony default export */ __webpack_exports__["ZP"] = (checkAvailbleDiscounts);


/***/ }),

/***/ 8523:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ calcProductImageFromSize; }
/* harmony export */ });
// This function takes the product image's actual size and floors / rounds / ceils it to a nearby whole, predefined number
// which has an image associated with it. It returns a string which should be used as name in the image path.
var calcProductImageFromSize = function(size) {
    var objSize = size < 1 ? 1 : size < 10 ? Math.floor(size) : size < 50 ? Math.ceil((size + 1) / 10) * 10 : Math.ceil(size / 25) * 25;
    return objSize.toString();
};


/***/ }),

/***/ 809:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(1799);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__(357);
var style_default = /*#__PURE__*/__webpack_require__.n(style);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chakra-ui-layout.esm.js
var chakra_ui_layout_esm = __webpack_require__(8527);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/button/dist/chakra-ui-button.esm.js
var chakra_ui_button_esm = __webpack_require__(5193);
// EXTERNAL MODULE: ./components/campaigns/CampaignBanner.tsx
var CampaignBanner = __webpack_require__(9841);
// EXTERNAL MODULE: ./components/HeadMeta.tsx
var HeadMeta = __webpack_require__(3636);
// EXTERNAL MODULE: ./constants/constants.tsx
var constants = __webpack_require__(3244);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/icons/dist/chakra-ui-icons.esm.js
var chakra_ui_icons_esm = __webpack_require__(9876);
// EXTERNAL MODULE: ./helpers/productHelpers.tsx
var productHelpers = __webpack_require__(8523);
// EXTERNAL MODULE: ./helpers/discounts.tsx
var helpers_discounts = __webpack_require__(2940);
// EXTERNAL MODULE: ./components/campaigns/DiscountPrice.tsx
var DiscountPrice = __webpack_require__(9410);
;// CONCATENATED MODULE: ./components/product/ProductCard.tsx










function ProductCard(param) {
    var product = param.product, facilityId = param.facilityId, discounts = param.discounts;
    var goToCheckout = function goToCheckout() {
        router.push({
            pathname: "/checkout",
            query: {
                p: product.id,
                f: facilityId
            }
        });
    };
    var router = (0,next_router.useRouter)();
    var objSize = (0,productHelpers/* calcProductImageFromSize */.I)(product.size);
    var filteredDiscounts = discounts.filter(function(discount) {
        return discount.appliesToProductId.includes(product.id);
    });
    var discountPrice = 0;
    if (filteredDiscounts.length > 0) {
        discountPrice = (0,helpers_discounts/* getDiscountPrice */.lk)(product.price, (0,helpers_discounts/* getBestDiscount */.vN)(product.price, filteredDiscounts));
    }
    var shouldShowHeading = product.name.includes("m3") || product.name.includes("Entr\xe9plan");
    var displayName = product.name;
    if (displayName.includes("Entr\xe9plan")) {
        displayName = displayName.substring(0, displayName.indexOf("Entr\xe9plan") + "Entr\xe9plan".length);
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Box */.xu, {
        onClick: goToCheckout,
        _hover: {
            transform: "translateY(-.3em)",
            boxShadow: constants/* elevation.+80 */.XC["+80"]
        },
        transition: ".15s all ease-in-out",
        cursor: "pointer",
        w: "100%",
        bg: constants/* colors.white */.O9.white,
        boxShadow: constants/* elevation.+20 */.XC["+20"],
        borderRadius: ".2em",
        overflow: "hidden",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Flex */.kC, {
                justify: "center",
                bg: constants/* colors.secondary.50 */.O9.secondary[50],
                mt: "-20px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                    transform: "translateY(40px)",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: "/images/objects/".concat(objSize, ".svg"),
                        alt: "f\xf6rr\xe5d ".concat(product.size, " kvadratmeter"),
                        width: 200,
                        height: 200
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Box */.xu, {
                p: "1.5em",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Box */.xu, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Heading */.X6, {
                                as: "h3",
                                variant: "productCardHeading",
                                children: [
                                    product.size,
                                    " m\xb2"
                                ]
                            }),
                            shouldShowHeading && /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Heading */.X6, {
                                as: "h3",
                                variant: "productCardHeading",
                                children: [
                                    "(",
                                    displayName,
                                    ")"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Flex */.kC, {
                        justifyContent: "space-between",
                        align: "center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                            mt: 3,
                            children: discountPrice > 0 && filteredDiscounts.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DiscountPrice/* default */.Z, {
                                price: product.price,
                                discount: (0,helpers_discounts/* getBestDiscount */.vN)(product.price, filteredDiscounts)
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Text */.xv, {
                                variant: "productCardMoney",
                                children: [
                                    product.price,
                                    ":-/m\xe5n"
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Flex */.kC, {
                        justifyContent: "space-between",
                        align: "center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_button_esm/* Button */.zx, {
                            rightIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_icons_esm/* ChevronRightIcon */.XC, {}),
                            fontWeight: "normal",
                            "aria-label": "V\xe4lj produkt",
                            variant: "ml",
                            onClick: goToCheckout,
                            children: "Boka"
                        })
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var product_ProductCard = (ProductCard);

// EXTERNAL MODULE: ./helpers/umbracoApi.tsx + 17 modules
var umbracoApi = __webpack_require__(3767);
;// CONCATENATED MODULE: ./pages/anlaggning/[slug].tsx












function FacilityInfo(param) {
    var content = param.content;
    var ref;
    var ref1 = (0,react.useState)(false), showMap = ref1[0], setShowMap = ref1[1];
    if (!content) {
        return null;
    }
    var _altText;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadMeta/* HeadMeta */.N, (0,_object_spread/* default */.Z)({}, content.meta)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                p: {
                    base: "0 2.5%",
                    md: "0 5%",
                    xl: "0 0"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Container */.W2, {
                    maxW: "7xl",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Grid */.rj, {
                            templateColumns: {
                                base: "1fr",
                                md: "7fr 5fr"
                            },
                            mt: {
                                base: "2em",
                                md: "6em"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* GridItem */.P4, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Flex */.kC, {
                                            flex: {
                                                base: 1,
                                                md: 3
                                            },
                                            flexDir: "column",
                                            mr: {
                                                base: 0,
                                                md: "5em"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                                                        mt: 4,
                                                        mb: 8,
                                                        size: "md",
                                                        children: content === null || content === void 0 ? void 0 : (ref = content.preamble) === null || ref === void 0 ? void 0 : ref.replace(/<[^>]*>?/gm, "")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* SimpleGrid */.MI, {
                                                    columns: 2,
                                                    spacingX: 10,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                                                            dangerouslySetInnerHTML: {
                                                                __html: content.information ? content.information.toString() : "Information om anl\xe4ggningen saknas"
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Box */.xu, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Heading */.X6, {
                                                                    as: "h2",
                                                                    size: "sm",
                                                                    mb: 7,
                                                                    children: [
                                                                        "Adress till lager i ",
                                                                        content.name
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                                                                    children: content.address ? content.address : "Adress f\xf6r anl\xe4ggning saknas"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                                                                    style: {
                                                                        transition: ".1s color ease-in-out",
                                                                        fontWeight: "bold"
                                                                    },
                                                                    _hover: {
                                                                        color: constants/* colors.primary.900 */.O9.primary[900]
                                                                    },
                                                                    children: content.phone ? /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                            href: "tel:".concat(content.phone),
                                                                            children: content.phone
                                                                        })
                                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                                                                        children: "Telefon f\xf6r anl\xe4ggning saknas"
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Link */.rU, {
                                            target: "_blank",
                                            href: "https://www.google.com/maps/dir/?api=1&destination=".concat(content.address, "&travelmode=driving"),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_button_esm/* Button */.zx, {
                                                variant: "primary",
                                                size: "lg",
                                                mt: 6,
                                                children: "Hitta hit"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* GridItem */.P4, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                                        flex: {
                                            base: "none",
                                            md: 2
                                        },
                                        bg: constants/* colors.secondary.50 */.O9.secondary[50],
                                        h: {
                                            base: 200,
                                            md: 200,
                                            lg: 300
                                        },
                                        pos: "relative",
                                        borderRadius: "1em",
                                        overflow: "hidden",
                                        alignItems: "center",
                                        d: "flex",
                                        mt: {
                                            base: "2em",
                                            md: 0
                                        },
                                        children: content.image ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    src: content.image._url,
                                                    alt: (_altText = content.image.altText) !== null && _altText !== void 0 ? _altText : "Bild p\xe5 anl\xe4gggning",
                                                    layout: "fill",
                                                    className: "facilityImage",
                                                    priority: true,
                                                    loading: "eager"
                                                }),
                                                (0,jsx_runtime.jsx)((style_default()), {
                                                    id: "825eb86a381b4991",
                                                    children: ".facilityImage{-o-object-fit:cover;object-fit:cover}"
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                                            textAlign: "center",
                                            flex: "1",
                                            color: constants/* colors.secondary.900 */.O9.secondary[900],
                                            children: "Bild saknas"
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                            mt: {
                                base: 10,
                                md: 20
                            },
                            mb: 3,
                            align: "center",
                            fontSize: 14,
                            color: constants/* colors.neutrals.500 */.O9.neutrals[500]
                        })
                    ]
                })
            })
        ]
    });
}
function Facility(param) {
    var products = param.products, facility = param.facility, facilityContent = param.facilityContent, sharedPageProps = param.sharedPageProps;
    var ref;
    var route = (0,next_router.useRouter)();
    console.log("PRODUCTS FOR THIS FACILITY", products);
    var filteredCampaigns = sharedPageProps === null || sharedPageProps === void 0 ? void 0 : sharedPageProps.campaigns.filter(function(campaign) {
        var ref;
        return (campaign.appliesToAll || ((ref = campaign.appliesToFacilityId) === null || ref === void 0 ? void 0 : ref.includes(facility.id))) && campaign.isActive;
    });
    var activeDiscounts = [];
    filteredCampaigns === null || filteredCampaigns === void 0 ? void 0 : filteredCampaigns.forEach(function(campaign) {
        return campaign === null || campaign === void 0 ? void 0 : campaign.discounts.forEach(function(discount) {
            return activeDiscounts.push(discount);
        });
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CampaignBanner/* default */.Z, {
                campaigns: sharedPageProps === null || sharedPageProps === void 0 ? void 0 : sharedPageProps.campaigns,
                campaignLevel: "Facility",
                id: facility === null || facility === void 0 ? void 0 : facility.id,
                title: facility === null || facility === void 0 ? void 0 : facility.name
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Box */.xu, {
                children: [
                    (products === null || products === void 0 ? void 0 : products.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                        p: {
                            base: "2em 5%",
                            md: "5em 5%",
                            xl: "5em 0"
                        },
                        bg: constants/* colors.secondary.300 */.O9.secondary[300],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Container */.W2, {
                            maxW: "7xl",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                                    mx: 0,
                                    mb: 20,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Heading */.X6, {
                                        as: "h1",
                                        size: "xl",
                                        children: !facilityContent.header ? route === null || route === void 0 ? void 0 : (ref = route.asPath) === null || ref === void 0 ? void 0 : ref.split("/anlaggning/")[1].replace("-", " ") : facilityContent.header
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* SimpleGrid */.MI, {
                                        columns: respCols,
                                        spacing: respSpacing,
                                        children: products.map(function(product) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(product_ProductCard, {
                                                product: product,
                                                facilityId: facility.id,
                                                discounts: activeDiscounts
                                            }, product.id);
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FacilityInfo, {
                                    content: (0,_object_spread/* default */.Z)({}, products, facility, facilityContent)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Box */.xu, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Heading */.X6, {
                                            as: "h2",
                                            size: "md",
                                            mt: 14,
                                            mb: 4,
                                            children: facilityContent.storeHeader
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                                            dangerouslySetInnerHTML: {
                                                __html: facilityContent.storeInformation.toString()
                                            }
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    (facilityContent === null || facilityContent === void 0 ? void 0 : facilityContent.blocks.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadMeta/* HeadMeta */.N, (0,_object_spread/* default */.Z)({}, facilityContent.meta)),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(umbracoApi/* BlockRenderer */.HO, {
                                blocks: facilityContent.blocks
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
var respCols = {
    base: 1,
    sm: 1,
    md: 2,
    lg: 3,
    xl: 3
};
var respSpacing = {
    base: "3em"
};
var __N_SSG = true;
/* harmony default export */ var _slug_ = (Facility);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(4309); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);